import React from "react";
import { UploadStatus } from "../../interfaces";
import { useTranslation } from "react-i18next";
import { Button, Checkbox, Loader } from "@mantine/core";
import SucessScreen from "./SuccessScreen";

type Props = {
  uploadStatus: UploadStatus | undefined;
  approved: boolean;
  setApproved: React.Dispatch<React.SetStateAction<boolean>>;
  image: File | null;
  handleS3Upload: () => void;
  isLarge: boolean;
};

const SendPrintdata: React.FC<Props> = ({
  uploadStatus,
  approved,
  setApproved,
  image,
  handleS3Upload,
  isLarge,
}) => {
  const { t } = useTranslation();

  return (
    <div className="send-printdata w-auto mt-10 mx-0">
      <div
        className="form-medium mt-10"
        style={{
          pointerEvents: !!image && !!uploadStatus ? "none" : "unset",
        }}
      >
        <Checkbox
          checked={approved}
          onChange={(e: any) => setApproved(e.target.checked)}
          label={t("approvePrintDataCorrect")}
        />
      </div>
      {uploadStatus === UploadStatus.UPLOADING ? (
        <div className="upload-status mt-10">
          <div className="upload-status__line">
            <span id="upload-line" />
          </div>
          <p className="upload-status__progress">
            <Loader size={28} /> <span id="upload-progress">0%</span>
          </p>
        </div>
      ) : uploadStatus === UploadStatus.DONE ? (
        <div className="upload-completed mt-10">
          <SucessScreen />
        </div>
      ) : uploadStatus === UploadStatus.PREUPLOADED ? (
        <Button mt={10} size="lg" loading />
      ) : (
        <Button mt={10} size="lg" onClick={handleS3Upload} disabled={!approved}>
          {t(isLarge ? "confirmFile" : "upload")}
        </Button>
      )}
    </div>
  );
};

export default SendPrintdata;
